import { useUnit } from 'effector-react'
import { useEffect } from 'react'
import { FromComeLocationEnum } from '../index.h'
import { setFromComeLocation } from '../model'

export function useSetFromComeLocation() {
  const setFromComeLocationEvent = useUnit(setFromComeLocation)

  useEffect(() => {
    setFromComeLocationEvent(FromComeLocationEnum.INIT)

    return () => {
      setFromComeLocationEvent(FromComeLocationEnum.LEFT)
    }
  }, [setFromComeLocationEvent])
}
